import { request } from '@/utils/request';

export const getUserList = params => request('/api/v1/system/user/page', 'get', params);

export const getUserDetail = params => request(`/api/v1/system/user/${params.id}`, 'get', params);

export const deleteUser = params => request(`/api/v1/system/user/delete`, 'post', params);

export const addUser = params => request(`/api/v1/system/user/create`, 'post', params);

export const editUser = params => request(`/api/v1/system/user/update`, 'post', params);

export const resetPwd = params => request(`/api/v1/system/user/update/password`, 'post', params);

export const inputUser = params => request(`/api/portal/user/import`, 'post', params);

export const changeStatus = params => request(`/api/v1/system/user/update/status`, 'post', params);

export const getRoleList = params => request('/api/v1/system/role/list', 'get', params);

export const getJobList = params => request('/api/v1/system/job/page', 'get', params);

export const getOrgTree = params => request('/api/v1/system/org/tree', 'get', params);

export const getpubTree = params => request('/api/v1/publish/directory/tree', 'get', params);

export const getPositionList = params => request('/api/v1/system/position/page', 'get', params);

export const uploadApi = params => request(`/api/v1/file/upload`, 'post', params);

// 获取用户的菜单权限
export const getMenuForCurrentUser = params =>
  request('/api/v1/system/auth/getMenuForCurrentUser', 'get', params);
